// Tzolk'in day count (GMT correlation). Deterministic; moved out of
// StarChartModule so the first-run screens don't load the whole module.
import { MAYAN_DAY_SIGNS, MAYAN_TONES } from "../../components/star-charts/constants.js";

export function calculateMayanChart(birthData) {
  const { birthDate } = birthData;

  // Anchor: December 21, 2012 UTC = Ajpu (index 19), Tone 4 (index 3 at 0-indexed).
  // This uses the GMT correlation constant, the most widely accepted standard.
  const anchor = new Date(Date.UTC(2012, 11, 21));
  const anchorDaySignIdx = 19; // Ajpu
  const anchorToneIdx = 3;     // Tone 4 (0-indexed)

  const birth = new Date(Date.UTC(birthDate.year, birthDate.month - 1, birthDate.day));
  const msPerDay = 86400000;
  const daysDiff = Math.round((birth.getTime() - anchor.getTime()) / msPerDay);

  // Modulo that handles negative numbers (birth dates before 2012).
  const mod = (n, m) => ((n % m) + m) % m;

  const daySignIdx = mod(anchorDaySignIdx + daysDiff, 20);
  const toneIdx = mod(anchorToneIdx + daysDiff, 13);

  return {
    daySign: MAYAN_DAY_SIGNS[daySignIdx],
    tone: MAYAN_TONES[toneIdx],
    daySignIdx,
    toneIdx,
  };
}

// The 365-day solar year (Ab' in the K'iche' count) and its Year Bearer, the
// day that falls on its first day. Anchor: the Academia de Lenguas Mayas de
// Guatemala marked the Ab' new year on February 18, 2025, a 13 Iq' day. The
// year has no leap day, so every start is a whole number of 365-day years
// from there, and the bearer always lands on Iq', Kej, E or No'j. Its last
// five days are the Wayeb'.
const AB_ANCHOR_UTC = Date.UTC(2025, 1, 18);
const DAY_MS = 86400000;

export function calculateMayanYearBearer(birthData) {
  const { birthDate } = birthData || {};
  if (!birthDate?.year) return null;
  const birth = Date.UTC(birthDate.year, birthDate.month - 1, birthDate.day);
  const sinceAnchor = Math.round((birth - AB_ANCHOR_UTC) / DAY_MS);
  const yearsBack = Math.floor(sinceAnchor / 365);
  const dayOfYear = sinceAnchor - yearsBack * 365; // 0..364
  const startMs = AB_ANCHOR_UTC + yearsBack * 365 * DAY_MS;
  const s = new Date(startMs);
  const start = { year: s.getUTCFullYear(), month: s.getUTCMonth() + 1, day: s.getUTCDate() };
  const bearer = calculateMayanChart({ birthDate: start });
  return {
    start,
    daySign: bearer.daySign,
    tone: bearer.tone,
    dayOfYear,
    wayeb: dayOfYear >= 360,
  };
}
